import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import { Sidebar } from "@/components/dashboard/Sidebar";
import { Header } from "@/components/dashboard/Header";
import Dashboard from "@/pages/Dashboard";
import Portfolio from "@/pages/Portfolio";
import Transactions from "@/pages/Transactions";
import Exchange from "@/pages/Exchange";
import Alerts from "@/pages/Alerts";
import Markets from "@/pages/Markets";
import Settings from "@/pages/Settings";
import DesignSystem from "@/pages/DesignSystem";
import BlockchainFlow from "@/pages/BlockchainFlow";

// Layout wrapper for dashboard pages
const DashboardLayout = ({ children }) => (
  <div className="flex h-screen bg-background overflow-hidden">
    <div className="hidden lg:block">
      <Sidebar />
    </div>
    <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
      <Header />
      <main className="flex-1 overflow-y-auto scrollbar-thin">
        {children}
      </main>
    </div>
  </div>
);

function App() {
  return (
    <ThemeProvider defaultTheme="dark">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            {/* All pages with sidebar layout */}
            <Route path="/" element={<DashboardLayout><Dashboard /></DashboardLayout>} />
            <Route path="/portfolio" element={<DashboardLayout><Portfolio /></DashboardLayout>} />
            <Route path="/blockchain-flow" element={<DashboardLayout><BlockchainFlow /></DashboardLayout>} />
            <Route path="/transactions" element={<DashboardLayout><Transactions /></DashboardLayout>} />
            <Route path="/markets" element={<DashboardLayout><Markets /></DashboardLayout>} />
            <Route path="/exchange" element={<DashboardLayout><Exchange /></DashboardLayout>} />
            <Route path="/alerts" element={<DashboardLayout><Alerts /></DashboardLayout>} />
            <Route path="/design-system" element={<DashboardLayout><DesignSystem /></DashboardLayout>} />
            <Route path="/settings" element={<DashboardLayout><Settings /></DashboardLayout>} />
            <Route path="/help" element={<DashboardLayout><Dashboard /></DashboardLayout>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
